module.exports = __webpack_public_path__ + "img/3_101.7c7b5912.png";